export const iconNames = [
  'calendar',
  'leaf',
  'frequency',
  'home',
  'mealPerBox',
  'profile',
  'portions',
]
